import { render, staticRenderFns } from "./PersonIcon.vue?vue&type=template&id=95bf9098"
import script from "./PersonIcon.vue?vue&type=script&lang=js"
export * from "./PersonIcon.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports